
const verifyTypes = {
    SMS: 'SMS',
    CALL: 'CALL'
};

const submitTranslates = {
    VERIFY: 'VERIFY',
    RETRY: 'RETRY'
};

class ExistsNumberValidate {
    [x: string]: any;
    constructor() {
      this.verifyType = verifyTypes.SMS;
    }

    setMsisdn() {
        this.onSetPhoneNumber({msisdn: this.msisdn, verifyType: this.verifyType});
    }

    getSubmitTranslate() {
        return this.currentMsisdn && this.currentMsisdn === this.msisdn
            ? submitTranslates.RETRY
            : submitTranslates.VERIFY;
    }
}

export default {
    controller: ExistsNumberValidate,
    template : require('./exists.number.validate.html'),
    bindings: {
        onSetPhoneNumber: '&',
        currentMsisdn: '<'
    }
}
